<div class="w-full p-10 flex flex-col justify-center">
    <p>Playlists</p>
    <app-addplaylist class="w-1/2 self-center" (refresh)="getPlaylists()"></app-addplaylist>
    <div class="w-full grid gap-4 grid-cols-[repeat(auto-fit,minmax(250px,1fr))]">

    @if(playlists().length === 0){
       <h2>No playlists found</h2>
    }@else{
      @for(playlist of playlists(); track $index) {
          <app-playlist [playlist]="playlist" class=""></app-playlist>
      }
    }
 
    </div>
</div>


